import script from "./Mobile.vue?vue&type=script&setup=true&lang=js"
export * from "./Mobile.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__